import type { GetAuthUserByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetAuthUserByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAuthUserByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetAuthUserByIdArgs = {
  id: string;
};

export const useGetAuthUserById = createQueryHook<
  UseGetAuthUserByIdArgs,
  GetAuthUserByIdResponseRow[],
  GetAuthUserByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.user.userById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ auth_user_by_pk: data[0] ?? null }),
  graphqlDocument: GetAuthUserByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
